import type { Sport } from '../types/landing';

export const sports: Sport[] = [
  {
    slug: 'soccer',
    name: 'Soccer',
    noun: 'soccer',
    leagueTitle: 'Youth Soccer Leagues',
    heroImage:
      'https://cdn.magicpatterns.com/uploads/71bcq1EUZZqgqqD5bX8jKM/A7508542.jpg',
    heroIntro:
      'i9 Sports® offers recreational youth soccer programs at convenient parks and fields throughout the {city} area. One day a week, everyone plays, and no tryouts.',
    seoHeading: 'Recreational soccer leagues for kids ages 3–14 in {city}',
    seoParagraphs: [
      'Looking for youth soccer in {city}? i9 Sports® runs recreational soccer leagues for kids ages 3–14 at neighborhood parks and fields across the area, from {neighborhoods}. Our programs are built for families who want their kids to learn the game, make friends and stay active, without the travel schedule or tryouts of club soccer.',
      'Kids soccer in {city} with i9 Sports meets one day a week, with a short practice right before each game, so a full season fits around school and work. Coaches teach age-appropriate skills like dribbling, passing and teamwork, and every player gets real playing time.',
      'Whether your child is kicking a ball for the first time or is ready for a more competitive rec experience, there is a soccer league for kids in {city} that fits your family’s schedule.',
    ],
    venueType: 'parks and fields',
    exploreBlurb: 'Dribbling, passing and teamwork at neighborhood fields.',
  },
  {
    slug: 'flag-football',
    name: 'Flag Football',
    noun: 'flag football',
    leagueTitle: 'Youth Flag Football Leagues',
    heroImage:
      'https://cdn.magicpatterns.com/uploads/u53bE9GBBKJXw8cksJRNy1/10_12_24___i9_Marketing0373.jpg',
    heroIntro:
      'i9 Sports® offers non-contact youth flag football programs at convenient parks and fields throughout the {city} area. One day a week, everyone plays, and no tryouts.',
    seoHeading: 'Non-contact flag football leagues for kids ages 4–14 in {city}',
    seoParagraphs: [
      'Looking for youth flag football in {city}? i9 Sports® runs non-contact flag football leagues for kids ages 4–14 at parks across the area, from {neighborhoods}. It is a fun, safe way for kids to learn football fundamentals.',
      'Kids flag football in {city} meets one day a week, with practice right before the game. Coaches teach throwing, catching, flag pulling and route running, and every player rotates through positions.',
      'From first-time players to kids who live for Friday-night football, there is a flag football league for kids in {city} that fits.',
    ],
    venueType: 'parks and fields',
    exploreBlurb: 'Non-contact football fundamentals for ages 4–14.',
  },
  {
    slug: 'basketball',
    name: 'Basketball',
    noun: 'basketball',
    leagueTitle: 'Youth Basketball Leagues',
    heroImage:
      'https://cdn.magicpatterns.com/uploads/8RsnKApmuDG8NDGZYX44ks/231008_i9_HL0617.jpg',
    heroIntro:
      'i9 Sports® offers recreational youth basketball programs at convenient indoor gyms throughout the {city} area. One day a week, everyone plays, and no tryouts.',
    seoHeading: 'Recreational basketball leagues for kids ages 3–14 in {city}',
    seoParagraphs: [
      'Looking for youth basketball in {city}? i9 Sports® runs recreational basketball leagues for kids ages 3–14 at community gyms across the area, from {neighborhoods}.',
      'Kids basketball in {city} meets one day a week, with practice right before the game. Coaches teach dribbling, passing, shooting and defense on age-appropriate hoops.',
      'Whether your child is shooting their first basket or working on a jump shot, there is a basketball league for kids in {city} that fits.',
    ],
    venueType: 'gyms',
    exploreBlurb: 'Indoor rec basketball on age-appropriate hoops.',
  },
];
